export const Links = {
  AccountTaxes: "/account/taxes",
  Calendar: "/calendar",
  HostHub: "/host-hub",
  Inbox: "/inbox",
  InboxBookingRequestsAndInquiries: "/inbox?filters=requests,inquiries",
  InboxUnreadMessages: "/inbox?filters=unread",
  InboxUpdateRequested: "/inbox?filters=update_requested",
  PrivacyPolicy: "/privacy",
  ReviewsAboutSpaces: "/reviews/about-spaces",
  TermsOfService: "/terms",
} as const;
